import { ApolloClient, InMemoryCache } from "@apollo/client";
import { BatchHttpLink } from "@apollo/client/link/batch-http";
import { SetContextLink } from "@apollo/client/link/context";
import { GraphQLError } from "graphql";
import posthog from "posthog-js";

let token = "";
export function setToken(tkn: string){
  token = tkn;
}

const authLink = new SetContextLink(({ headers }) => {
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
      "X-Session-Id": posthog.get_session_id(),
    },
  };
});

const httpLink = new BatchHttpLink({
  uri: process.env.REACT_APP_GRAPHQL_URL,
  batchMax: 5,
  batchInterval: 50, // Wait no more than 50ms after first batched operation
});

export const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),

  defaultOptions: {
    query: { errorPolicy: "all" },
  },
  devtools: {
    enabled: true
  },
});

export function getSubErrors(err: any): Error[] | string[] | null {
  // Old style network errors
  if (err.errors) {
    return err.errors as Error[];
  }

  // Apollo errors
  if (err instanceof GraphQLError) {
    return [err.message];
  }

  return null;
}
